<template>
  <div class="declare-all">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline selectForm"
    >
      <el-form-item label="项目名称：">
        <el-input
          v-model="formInline.name"
          placeholder="请输入项目名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
        >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      class="applyTable"
      ref="multipleTable"
      :data="tableDataAll"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    ><!--@row-click="handleClickDetail"-->
      <el-table-column prop="name" label="项目名称" align="left" width="300">
      </el-table-column>
      <el-table-column prop="companyName" label="企业名称" align="center">
      </el-table-column>
      <el-table-column
        prop="supportAmount"
        label="金额(元)"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.supportAmount">{{scope.row.supportAmount}}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="申报日期"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="state" label="状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.state == 1">已申报</span>
          <span v-if="scope.row.state == 2">办理中</span>
          <span v-if="scope.row.state == 3">已办结</span>
          <span v-if="scope.row.state == 4">已驳回</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="suggest"
        label="审批意见"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.suggest">{{scope.row.suggest}}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="handleSearch(scope.row)">{{scope.row.state == 4?'修改':'查看'}}</el-button>
<!--          <el-button type="primary" size="small" v-if="scope.row.state == 4" @click="handleSearch(scope.row)">修改</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <div class="applyPagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog class="dialog" :visible.sync="dialogShow" :title="detailTitle" width="70%">
      <div class="details-box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="申报信息" name="first">
            <div class="declare_fill">
              <h3 style="margin-top: 0">项目内容</h3>
              <ul class="content-details">
                <li>
                  <p><span>项目名称</span><span>{{ projectContent.name }}</span></p>
                  <p><span>项目类型</span><span>{{ projectContent.type }}</span></p>
                </li>
              </ul>
              <h3>企业信息</h3>
              <ul class="content-details">
                <li>
                  <p><span>企业名称</span><span>{{ projectContent.companyName }}</span></p>
                  <p><span>统一社会信用代码</span><span>{{ projectContent.licenseNum }}</span></p>
                </li>

                <li>
                  <p><span>注册地址</span><span>{{ projectContent.companyAddress }}</span></p>
                  <p><span>企业银行账户名称</span><span>{{ projectContent.companyName }}</span></p>
                </li>
                <li>
                  <p><span>企业法人名称</span><span>{{ projectContent.frName }}</span></p>
                  <p><span>企业法人电话</span><span>
                <el-input
                  placeholder="请输入联系人电话"
                  v-model="ruleForm.frPhone"
                ></el-input
                ></span>
                  </p>
                  <!--              <p><span>企业法人电话</span><span>{{ projectContent.frPhone }}</span></p>-->
                </li>
                <li>
                  <p>
                    <span>企业银行开户行</span>
                    <span><el-input
                      placeholder="请输入企业银行开户行"
                      v-model="ruleForm.khh"
                    ></el-input
                    ></span>
                  </p>
                  <p>
                    <span>企业银行账号</span>
                    <span>
            <el-input
              placeholder="请输入企业银行账号"
              v-model="ruleForm.yhNum"
            ></el-input
            ></span>
                  </p>

                </li>
                <li>
                  <p>
                    <span>联系人</span>
                    <span><el-input
                      placeholder="请输入联系人"
                      v-model="ruleForm.lxrName"
                    ></el-input
                    ></span>
                  </p>
                  <p>
                    <span>联系人电话</span>
                    <span>
            <el-input
              placeholder="请输入联系人电话"
              v-model="ruleForm.lxrPhone"
            ></el-input
            ></span>
                  </p>

                </li>

              </ul>
              <h3>附件资料</h3>
              <div class="warning_message">
                 <p>温馨提示：</p>
                 <p>
                   1、请按照附件要求，每条记录以一个文件形式上传，如果多个文件则先合并为一个文件（建议DOC或PDF或ZIP格式）后上传。
                 </p>
                 <p>
                   2、视频文件不超过2GB，其他类型文件不超过50M，格式为JPG、PNG、DOC、DOCX、WPS、PDF、XLS、XLSX、ZIP格式的文件。
                 </p>
                 <p>3、对于大于一页的单个附件，如审计报告等，建议采用PDF格式。</p>
                 <p>
                   4、附件材料的复印件或者原件，以扫描或者拍照的形式，确保足够清晰、否则将影响单位信息的审核，直至专项资金的审批拨付。
                 </p>
                <p style="font-weight: bold;color: #000;font-size: 16px">本次需要提交的申报材料如下：</p>
                <div v-if="materialsList&&materialsList.length>0">
                  <p v-for="(item,i) in materialsList" :key="i">
                    {{i+1}}、{{item.materialName}}
                  </p>
                </div>
                <div class="filelist">
                  <label>附件</label>
                  <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :headers="headers"
                    :disabled="projectContent.state != 4"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="10"
                    :on-exceed="handleExceed"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :file-list="fileList"
                  ><!--:show-file-list="false"-->
                    <el-button type="primary" :disabled="projectContent.state != 4"
                    >附件上传</el-button
                    >
                  </el-upload>
                </div>
                <!--<div class="filelist">
                  &lt;!&ndash;                      <label>附件</label>&ndash;&gt;
                  <ul class="file-lists" v-if="projectContent.fileList&&projectContent.fileList.length>0">
                    <li v-for="(item,i) in projectContent.fileList" :key="i">{{i+1}}、<a :href="item.url">{{item.name}}</a></li>
                  </ul>
                </div>-->
              </div>
              <h3>申报信息</h3>
              <ul class="content-details">
                <li>
                  <p><span>扶持金额</span><span>{{ projectContent.supportAmount }}</span></p>
                  <p><span>申报状态</span><span>{{ projectContent.state == 1? "已申报": projectContent.state == 2?"受理中": projectContent.state == 3?"已办结":projectContent.state == 4?"已驳回":""}}</span></p>
                </li>
                <li>
                  <div v-if="projectContent.state == 4" class="reject_reason"><span>审核意见</span><span>{{projectContent.suggest}}</span></div>
                </li>
              </ul>
              <div style="width: 100%;">
                <el-button type="primary" size="small" style="height: 42px;margin: 20px auto;display: block" v-if="projectContent.state == 4" @click="submitApply()">重新申请</el-button>
              </div>

            </div>
          </el-tab-pane>
          <el-tab-pane label="信用承诺书" name="second">
            <div class="declare_fill">
              <h3>信用承诺书</h3>
              <div class="commitment_msg" style="padding-top: 20px">
                <div class="p_l20" v-html="projectContent.cnh"></div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { declareProjectPageList } from "@/api/noApply";
import { detail_apply } from "@/api/policy";
import { declareItemAdd } from "@/api/account";
import { getStorage } from "@/common/utils";
import cookie from "js-cookie";
import config from "@/config";
export default {
  name: 'DeclareAll',
  data() {
    return {
      formInline: {
        name: "",
      },
      value1: "",
      rateValue: null,
      currentPage: 1,
      total: 0,
      tableDataAll: [],
      dialogShow: false,
      materialsList: [],
      projectContent: {},
      detailTitle: '',
      tabList:['申报信息','信用承诺书'],
      activeName: 'first',
      ruleForm: {
        frPhone: "",
        khh: "",
        yhNum: "",
        lxrName: "",
        lxrPhone: "",
        fileList: [],
      },
      fileList: [],
      uploadUrl: `${config.commonUrl}common/upload/fileTemplate`,
      headers: { accessToken: getStorage("token") },
    };
  },
  mounted() {
    this.getData();
  },
  methods:{
    getProjectMessage(directionId,projectId){
      detail_apply(projectId).then(res=>{
        if(res.data.success){
          let datas = res.data.result
          if(directionId){
            if(datas.adminDeclareItemDirections&&datas.adminDeclareItemDirections.length>0){
              let directionIndex = datas.adminDeclareItemDirections.findIndex(item=>item.id == directionId)
              let directionItem = datas.adminDeclareItemDirections[directionIndex]
              this.materialsList = directionItem.adminDeclareItemMaterials
            }else{
              this.materialsList = []
            }
          }
        }
      })
    },
    getData() {
      const payload = {
        name: this.formInline.name,
        pageNumber: this.currentPage,
        pageSize: 10,
      };
      /*if (this.formInline.time && this.formInline.time.length == 2) {
        payload.stime = this.formInline.time[0];
        payload.etime = this.formInline.time[1];
      }*/
      declareProjectPageList(payload).then(({ data }) => {
        const { code, result, message } = data;
        if (code == 200) {
          this.tableDataAll = result.records;
          this.total = result.total;
        }
      });
    },
    handleSearch(row){
      this.dialogShow = true
      this.projectContent = row;
      this.detailTitle = row.name+'详情'
      this.ruleForm.frPhone = row.frPhone
      this.ruleForm.lxrPhone = row.lxrPhone
      this.ruleForm.khh = row.khh
      this.ruleForm.yhNum = row.yhNum
      this.ruleForm.lxrName = row.lxrName
      let nameArr = [],urlArr = []
      if(row.fileName){
        nameArr = row.fileName.split(",")
      }
      if(row.fileUrl){
        urlArr = row.fileUrl.split(",")
      }

      let arr = [],newArr = []
      urlArr.map((item,i)=>{
        arr.push({file: nameArr[i], ossUrl: item})
        newArr.push({name:nameArr[i], url: item})
      })
      this.fileList = newArr
      this.ruleForm.fileList = arr
      this.getProjectMessage(row.itemDirectionId,row.itemId)
      // this.formValidate.supportAmount = row.supportAmount;
      // this.formValidate.state = row.state.toString();
      // if(this.formValidate.state == 4){
      //   this.formValidate.suggest = row.suggest;
      // }
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
        .then(() => {
          let deleteIndex = this.ruleForm.fileList.findIndex(item=> item.ossUrl == file.url)
          this.ruleForm.fileList.splice(deleteIndex,1)
          // this.ruleForm.fileList.splice(deleteIndex,1)
          /*let arr = fileList.filter((obj) => obj.uid != file.uid);
          this.fileList = [];
          arr.forEach((item) => {
            this.fileList.push(item.response.result.id);
          });*/
          return true;
        })
        .catch(() => {});
    },
    onChange(file, fileList) {
      file.status = "success";
      this.fileList = fileList;
      console.log(this.fileList, fileList, "filelist");
    },
    handleSuccess(res) {
      if (res.code == 200) {
        this.fileList.push(res.result.id);
        this.ruleForm.fileList.push(res.result);
      } else {
        this.$message.warning(res.message);
      }
    },
    handleError(err) {
      this.$message.warning(JSON.parse(err.message).message);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
        files.length + fileList.length
          } 个文件`
      );
    },
    handleClick(tab){
      this.activeName = tab.name
    },
    submitApply() {
      if (cookie.get("accessToken")) {
        let formdata = {};

        for (let key in this.ruleForm) {
          if (key != "fileList") {
            if (!this.ruleForm[key]) {
              console.log(this.ruleForm, 88888)
              this.$message.warning("请填写企业信息");
              return;
            } else {
              formdata[key] = this.ruleForm[key]
            }
          } else {
            if (this.ruleForm.fileList.length) {
              console.log(this.ruleForm.fileList, 87654)
              let nameArr = [],fileArr = []
              this.ruleForm.fileList.map(item=>{
                nameArr.push(item.file)
                fileArr.push(item.ossUrl)
              })
              formdata.fileName = nameArr.join(",")
              formdata.fileUrl = fileArr.join(",")
            } else {
              formdata.fileName = ""
              formdata.fileUrl = ""
            }
          }
        }
        formdata["companyName"] = this.projectContent.companyName;//企业名称
        formdata["zhmc"] = this.projectContent.companyName;//企业银行账户名称
        formdata["cnh"] = this.projectContent.cnh;//承诺函信息
        formdata["frName"] = this.projectContent.legalName;//法人名称
        formdata["companyAddress"] = this.projectContent.companyAddress;//企业地址
        formdata["licenseNum"] = this.projectContent.licenseNum;//企业统一社会信用代码
        formdata["name"] = this.projectContent.title;//申报项目名称
        formdata["supportAmount"] = this.projectContent.money;//扶持金额
        formdata["type"] = this.projectContent.type;//扶持金额
        formdata["itemDirectionId"] = this.projectContent.itemDirectionId;
        formdata["itemId"] = this.projectContent.itemId;
        declareItemAdd(formdata).then((res) => {
          if (res.data.code == 200) {
            this.$message.success("申报成功");
            this.dialogShow = false
            this.getData()
          }
        });
      } else {
        this.$message({
          message: "请先登录",
          type: "warning",
        });
      }
    },
    handleReApply(row){
      this.$router.push({
        name: "DetailReportDeclare",
        query: {
          directionId: row.itemDirectionId,
          projectId: row.itemId,
          id: row.id
        },
      });
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
  }
}
</script>

<style lang="scss" >
.declare-all {
  .applyTab {
    /deep/ .el-tabs__header{
      .el-tabs__nav-wrap{
        .el-tabs__nav-scroll{
          .el-tabs__nav{
            .el-tabs__active-bar{
              transform: none !important;
            }
          }
        }
      }
    }

    /*border-top: 2px solid #e4e7ed;*/
    /deep/.el-tabs__item {
      font-size: 16px;
      height: 50px;
      line-height: 50px;
      color: rgba(56, 56, 56, 1);
    }
    /deep/.selectForm {
      .el-form-item {
        margin-right: 5%;
      }
      .el-date-editor .el-range-separator {
        width: 10%;
      }
    }
  }
  .applyTable {
    &::before {
      height: 0;
    }
    height: 530px;
    overflow: auto;
    /deep/.has-gutter tr th {
      background-color: rgba(250, 250, 250, 1);
    }

    .rejectIcon {
      font-size: 19px;
      margin-left: 3px;
      vertical-align: text-bottom;
    }
    .statuColor::before {
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 5px;
    }
    .applying::before {
      background-color: rgba(24, 144, 255, 1);
    }
    .applypass::before {
      background-color: rgba(67, 207, 124, 1);
    }
    .applyreject::before {
      background-color: rgba(245, 34, 45, 1);
    }
    .uploaddata::before {
      background-color: rgb(25, 207, 231);
    }
    .tocash::before {
      background-color: rgba(255, 141, 26, 1);
    }
    .givrup::before {
      background-color: rgba(0, 0, 0, 0.25);
    }
  }
  .applyPagination {
    text-align: right;
    margin-top: 10px;
  }
  .el-button--primary:focus,
  .el-button--primary:hover {
    background-color: #4988df;
    border-color: #4988df;
  }
  .dialog_rate {
    /deep/ .el-dialog {
      margin-top: 20% !important;
      .form-item {
        display: flex;
        span {
          height: 28px;
          line-height: 28px;
          margin-right: 20px;
        }
        .el-rate {
          height: 30px;
          line-height: 30px;
          .el-rate__item {
            margin-right: 0;
            .el-rate__icon {
              font-size: 24px;
            }
          }
        }
      }
    }
  }
  .details-box{
    width: 90%;
    margin: 0 auto;
    .declare_fill {
      width: 100%;

      h3 {
        margin: 15px auto 0;
        padding-bottom: 10px;
        border-bottom: 1px solid #ededed;
        font-size: 16px;
      }
      .content-details {
        margin: 0 auto;
        padding: 0;

        li {
          width: 100%;
          display: flex;
          list-style: none;
          font-size: 16px;
          color: #999;
          line-height: 45px;
          /*margin: 25px 0;*/
          p{
            width: 50%;
            margin: 0;
            font-size: 14px;
            display: flex;
            span {
              &:first-child {
                color: #333;
                margin-right: 10px;
                width: 130px;
                display: inline-block;

              }
              &:last-child{
                flex: 1;
                .el-input {
                  width: 90%;
                }
              }

            }
          }
          .reject_reason{
            width: 100%;
            margin: 0;
            font-size: 14px;
            display: flex;
            line-height: 30px;
            span {
              &:first-child {
                color: #333;
                margin-right: 10px;
                width: 130px;
                display: inline-block;
              }
            }
          }
          /deep/ .el-input {
            width: 300px;
          }
        }

      }
      .warning_message {
        padding: 15px 0;
        p {
          padding-left: 5px;
          color: #666666;
          font-size: 14px;
          letter-spacing: 1px;
          line-height: 24px;
          span {
            color: rgb(249, 84, 17);
          }
        }
        .filelist {
          margin-top: 10px;
          margin-left: 7px;
          overflow: hidden;
          /*display: flex;
          align-items: center;*/
          label {
            margin-right: 20px;
            float: left;
            line-height: 40px;
          }
          .upload-demo{
            width: 80%;
            .el-upload{
              .el-button{
                color: #ffffff;
                background-color: #4988df;
                border-color: #4988df;
              }
            }
            .el-upload-list{
              width: 90%;
              float: left;
              padding-left: 48px;
            }
          }
          .file-lists{
            width: 80%;
            float: left;
            list-style: none;
            padding-left: 10px;
            li{
              line-height: 26px;
              font-size: 14px;
              a{
                color: #666666;
                font-size: 14px;
                &:hover{
                  color: #1990ff;
                }
              }
            }
          }

        }

      }
      .file_first_page {
        width: 80%;
        margin: 40px auto;
        .page_subtitle {
          border-bottom: 1px solid #666666;
          text-align: right;
          padding-bottom: 10px;
          padding-right: 5%;
        }
        .project_message {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 200px;
          padding: 0 5%;
          p {
            &:first-child {
              .add_line {
                display: inline-block;
                margin: 3px 5px;
                text-decoration: underline;
              }
            }
          }
        }
        h3 {
          text-align: center;
          font-size: 28px;
          margin: 80px 0 200px;
        }
        .base_message {
          width: 100%;
          margin-bottom: 150px;
          p {
            display: flex;
            justify-content: center;
            margin-bottom: 30px;
            span {
              display: flex;
              justify-content: center;
              &:first-child {
                flex: 2;
                justify-content: flex-end;
              }
              &.add_line {
                flex: 3;
                justify-content: flex-start;
                margin-bottom: 3px;
                position: relative;
                &::after {
                  position: absolute;
                  width: 60%;
                  height: 1px;
                  left: 0;
                  bottom: -4px;
                  background-color: #666666;
                  content: "";
                }
              }
            }
          }
        }
      }
      .btn-list {
        width: 100%;
        display: flex;
        justify-content: center;
        .el-button {
          a {
            text-decoration: none;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>